import React from "react";
import { useTranslation } from "react-i18next";

const SystemBadge = () => {
  const { t } = useTranslation();
  return (
    <span className="bg-blue-100 text-blue-800 text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap">
      {t('templates.common.system_badge')}
    </span>
  );
};

export default SystemBadge;
